import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { getList, getImageById } from './logUsuarioActions';
import SPButton from '../common/form/spButton';
import Button from '../common/form/button';
import ReactTable from '../common/grid/gridReactTable';
import If from '../common/operator/if';
import { PAGE_SIZE } from '../common/utils/pageSize';

moment.locale('pt-br');

class LogUsuarioList extends Component {
  constructor(props) {
    super(props);

    this.getImage = this.getImage.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.handleChangeTime = this.handleChangeTime.bind(this);

    this.state = {
      show: false,
      html: '',
      dataAlteracao: '',
      data: [],
      pages: null,
      loading: false,
    };

    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    // Quando o componente monta, define loading como false se já tem dados
    if (this.props.data && this.props.data.length > 0) {
      this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    // Quando os dados mudam de vazio para com dados, define loading como false
    if (
      this.state.loading &&
      this.props.data &&
      this.props.data.length > 0 &&
      (!prevProps.data || prevProps.data.length === 0)
    ) {
      this.setState({ loading: false });
    }
  }

  fetchData(state) {
    this.setState({ loading: true });

    this.props.getList(state.page, state.sorted, state.filtered).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  handleClose() {
    this.setState({ show: false });
  }

  async getImage(id, data, rowData) {
    this.setState({ loading: true });
    const image = await this.props.getImageById(id).then(() => {
      return this.props.image;
    });
    this.setState({ loading: false });

    if (image !== null) {
      // Tentar diferentes formatos de data para evitar "Invalid date"
      let dataFormatada;
      try {
        dataFormatada = moment(data).format('DD/MM/YYYY HH:mm:ss');
      } catch (error) {
        // Fallback se moment falhar
        dataFormatada = data || 'Data não disponível';
      }

      // Verificar se existem múltiplas imagens (novo formato)
      let imageContent;
      try {
        const parsedImage = JSON.parse(image);
        if (parsedImage.allImages && Array.isArray(parsedImage.allImages)) {
          // Múltiplas páginas - mostrar todas
          imageContent = (
            <div>
              <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
                {parsedImage.allImages.length} página(s) capturada(s):
              </p>
              {parsedImage.allImages.map((img, index) => (
                <div key={index} style={{ marginBottom: '20px' }}>
                  <h5 style={{ marginBottom: '10px' }}>Página {index + 1}:</h5>
                  <img
                    src={img}
                    alt={`Página ${index + 1}`}
                    style={{
                      maxWidth: '100%',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      marginBottom: '10px',
                    }}
                  />
                </div>
              ))}
            </div>
          );
        } else {
          // Formato antigo - uma imagem
          imageContent = <img src={`${image}`} alt="" style={{ maxWidth: '100%' }} />;
        }
      } catch (error) {
        // Se não conseguir fazer parse, tratar como imagem simples
        imageContent = <img src={`${image}`} alt="" style={{ maxWidth: '100%' }} />;
      }

      this.setState({
        html: imageContent,
        dataAlteracao: dataFormatada,
      });
      this.setState({ show: true });
    }
  }

  timeFormat(time) {
    let timeFormatted = time.replace(/\D/g, '');
    let hour = timeFormatted.substring(0, 2);
    let minute = timeFormatted.substring(2, 4);
    let second = timeFormatted.substring(4, 6);
    hour = hour > 23 ? '23' : hour;
    minute = minute > 59 ? '59' : minute;
    second = second > 59 ? '59' : second;
    return `${hour}${minute ? ':' + minute : ''}${second ? ':' + second : ''}`;
  }

  handleChangeTime(value, onChange) {
    const time = this.timeFormat(value);
    onChange(time);
  }

  render() {
    const { data, total, ips } = this.props;

    const pages = Math.ceil(total / PAGE_SIZE);

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <If condicao={!!row.original.has_image}>
            <SPButton
              type="button"
              className="success btn btn-sm"
              icon="search"
              data-title=""
              onClick={() => this.getImage(row.original.id, row.original.data_hora_completa, row.original)}
            />
          </If>
        ),
        className: 'column_icon',
        width: 80,
        sortable: false,
        filterable: true,
        resizable: true,
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Tela',
        accessor: 'tabela_nome',
        width: 140,
        className: 'column_grid',
        filterable: true,
        resizable: true,
        Cell: ({ value }) => {
          switch (value) {
            case 'controlador':
              return 'Controlador';
            case 'data_especial':
              return 'Data Especial';
            case 'intervalo':
              return 'Intervalo Plano';
            case 'plano':
              return 'Plano';
            case 'tabela_troca':
              return 'Tabela de Troca';
            case 'plano_forcado':
              return 'Plano Forçado';
            default:
              return true;
          }
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={e => onChange(e.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'Todos'}
            name="tabela_nome"
          >
            <option value="">Todos</option>
            <option value="controlador">Controlador</option>
            <option value="data_especial">Data Especial</option>
            <option value="intervalo">Intervalo Plano</option>
            <option value="plano">Plano</option>
            <option value="tabela_troca">Tabela de Troca</option>
            <option value="plano_forcado">Plano Forçado</option>
          </select>
        ),
      },
      {
        Header: 'Usuário',
        accessor: 'usuario_desc',
        width: 110,
        className: 'column_grid',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Data',
        accessor: 'data_registro',
        width: 110,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => moment(value).format('DD/MM/YYYY'),
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            style={{ width: '100%' }}
            type="date"
            name="data_registro"
            className="form-control"
          />
        ),
      },

      {
        Header: 'Hora',
        accessor: 'hora_registro',
        width: 90,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => this.handleChangeTime(event.target.value, onChange)}
            value={filter ? filter.value : ''}
            type="text"
            name="hora_registro"
            maxLength={8}
            placeholder="hh:mm:ss"
            className="form-control"
          />
        ),
      },
      {
        Header: 'Ação',
        accessor: 'tipo',
        width: 110,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Cell: ({ value, original }) => {
          if (original && original.tabela_nome === 'controlador' && parseInt(value) === 2) {
            try {
              const dados = typeof original.dados === 'string' ? JSON.parse(original.dados) : original.dados;
              // "Online/Offline" deve aparecer apenas quando a ação foi explícita (lista de controladores),
              // que envia payload com `controlador_id` na rota PUT /controladores/:id/status.
              if (dados && dados.controlador_id && (dados.ativo === 1 || dados.ativo === -1)) {
                return dados.ativo === 1 ? 'Online' : 'Offline';
              }
            } catch (e) {}
          }

          switch (value) {
            case 1:
              return 'Cadastro';
            case 2:
              return 'Alteração';
            case 3:
              return 'Exclusão';
            case 4:
              return 'Reset (Central)';
            case 5:
              return 'Envia';
            default:
              return true;
          }
        },
        filterMethod: (filter, row) => {
          switch (filter.value) {
            case 'Cadastro':
              return parseInt(row[filter.id]) === 1;
            case 'Alteração':
              return parseInt(row[filter.id]) === 2;
            case 'Exclusão':
              return parseInt(row[filter.id]) === 3;
            case 'Reset (Central)':
              return parseInt(row[filter.id]) === 4;
            case 'Envia':
              return parseInt(row[filter.id]) === 5;
            default:
              return true;
          }
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'Todos'}
            name="tipo"
          >
            <option value="">Todos</option>
            <option value="1">Cadastro</option>
            <option value="2">Alteração</option>
            <option value="3">Exclusão</option>
            <option value="4">Reset (Central)</option>
            <option value="5">Envia</option>
          </select>
        ),
      },
      {
        Header: 'Grupo',
        accessor: 'grupo_fisico',
        width: 70,
        className: 'column_grid column_center',
        filterable: false,
        resizable: true,
      },
      {
        Header: 'Controlador',
        accessor: 'numero_controlador',
        width: 100,
        filterable: false,
        className: 'column_grid column_center',
        resizable: true,
      },
      {
        Header: 'IP/Porta',
        accessor: 'ip_porta',
        width: 160,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Filter: ({ filter, onChange }) => {
          const value = filter ? filter.value : '';
          return (
            <select class={'form-control'} onChange={event => onChange(event.target.value)} value={value}>
              <option value="">Todos</option>
              {ips &&
                ips.map(ip => (
                  <option key={ip} value={ip}>
                    {ip}
                  </option>
                ))}
            </select>
          );
        },
      },
      {
        Header: 'Anel',
        accessor: 'anel',
        width: 60,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
      },
    ];

    return (
      <>
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-mapa">
          <Modal.Header className="modal-header" closeButton>
            <Modal.Title>Log de Alteração {this.state.dataAlteracao}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body" align="center">
            {this.state.loading ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#3c8dbc' }} />
                <br />
                <p style={{ marginTop: '10px', color: '#666' }}>Carregando imagem...</p>
              </div>
            ) : (
              this.state.html
            )}
          </Modal.Body>
          <Modal.Footer className="modal-header">
            <Button type="button" className="primary" icon="close" label="Fechar" onClick={this.handleClose} />
          </Modal.Footer>
        </Modal>

        <ReactTable
          manual
          data={data}
          columns={columns}
          pages={pages}
          loading={this.state.loading}
          onFetchData={this.fetchData}
          filterable
          className="-striped -highlight"
          defaultPageSize={PAGE_SIZE}
          showPaginationBottom={true}
        />
      </>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getList, getImageById }, dispatch);
export default connect(
  state => ({
    data: state.logusuarioCad.list,
    total: state.logusuarioCad.total,
    ips: state.logusuarioCad.ips,
    image: state.logusuarioCad.image,
  }),
  mapDispatchToProps,
)(LogUsuarioList);
